"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VerifyNow = void 0;
const loader_1 = require("./loader");
const library_1 = require("../../core/library");
class VerifyNow extends library_1.Library {
    constructor(verifyNowUrl) {
        super('VerifyNow', new loader_1.VerifyNowLoader(verifyNowUrl));
    }
    setVerifyNowCallback(callback) {
        window.onVnVerificationComplete = callback;
    }
}
exports.VerifyNow = VerifyNow;
//# sourceMappingURL=index.js.map